__turbopack_context__.v({
  "icon": "ActionIcon-Minimal-module__6oHycG__icon",
  "loader": "ActionIcon-Minimal-module__6oHycG__loader",
  "root": "ActionIcon-Minimal-module__6oHycG__root",
});
